import classnames from "classnames";
import IDialogPropTypes from "rc-dialog/lib/IDialogPropTypes";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import AnimatedDialog from "../AnimatedDialog/AnimatedDialog";

// tslint:disable-next-line:no-var-requires
const styles = require("./ValidationErrorDialog.scss");

export interface ValidationErrorDialogProps {
    isValid?: boolean;
    validationTimestamp: number;
}

export interface ValidationErrorDialogState {
    popupShowed: boolean;
    lastSubmitTimestamp?: number;
}

export class ValidationErrorDialog extends React.Component<
    ValidationErrorDialogProps & IDialogPropTypes & WithTranslation,
    ValidationErrorDialogState
> {
    public static getDerivedStateFromProps(
        props: ValidationErrorDialogProps & IDialogPropTypes & WithTranslation,
        state: ValidationErrorDialogState
    ) {
        if (props.validationTimestamp !== state.lastSubmitTimestamp) {
            return {
                lastSubmitTimestamp: props.validationTimestamp,
                popupShowed: props.isValid === false
            };
        }
        return null;
    }

    constructor(
        props: ValidationErrorDialogProps & IDialogPropTypes & WithTranslation
    ) {
        super(props);

        this.state = { popupShowed: false };
    }

    public render() {
        const {
            isValid,
            validationTimestamp,
            children,
            i18n,
            t,
            ...props
        } = this.props;
        return (
            <AnimatedDialog visible={this.popupShowed} {...props}>
                {children}
                <footer className={classnames(styles.validationDialogFooter)}>
                    <button onClick={this.hide}>{t("OK")}</button>
                </footer>
            </AnimatedDialog>
        );
    }

    private get popupShowed() {
        return !this.props.isValid && this.state.popupShowed;
    }
    private hide = () =>
        this.setState({
            popupShowed: false
        });
}

export default withTranslation()(ValidationErrorDialog);
